import { baseThemeValues } from 'constants/common';

import { headerCellTheme } from './Cells/HeaderCell/theme';
import { multiItemsCellTheme } from './Cells/MultiItemsCell/theme';
import { progressCellTheme } from './Cells/ProgressCell/theme';
import { rowCellTheme } from './Cells/RowCell/theme';
import { columnsFilterTheme } from './TopToolbar/theme';

export const dataGridTheme = {
  columnsFilter: columnsFilterTheme,
  container: {
    borderColor: 'palette.transparent',
    borderRadius: '10px',
    borderWidth: '0px',
    scrollbarBg: 'palette.surface.1',
  },
  customPagination: {
    button: {
      active: {
        bg: 'palette.primary.20',
        text: 'palette.primary.99',
      },
      base: {
        bg: 'palette.transparent',
        borderColor: 'palette.transparent',
        borderRadius: '6px',
        borderWidth: '0px',
        fontFamily: baseThemeValues.inherit,
        fontSize: '14px',
        fontWeight: 600,
        text: 'palette.tertiary.80',
      },
      disabled: {
        text: 'palette.neutral.20',
      },
      hover: {
        bg: 'palette.surface.4',
      },
      pressed: {
        bg: 'palette.surface.5',
      },
    },
    ellipsis: 'palette.tertiary.80',
    itemsCount: 'palette.tertiary.60',
  },
  headerCell: headerCellTheme,
  itemsPerPage: 'palette.tertiary.60',
  multiItemsCell: multiItemsCellTheme,
  pagination: {
    button: {
      base: {
        borderColor: 'palette.transparent',
        borderRadius: '8px',
        borderWidth: '0px',
        text: 'palette.tertiary.30',
      },
      disabled: {
        bg: 'palette.transparent',
        text: 'palette.neutral.10',
      },
      hover: {
        bg: 'palette.tertiary.5',
        text: 'palette.primary.90',
      },
      pressed: {
        bg: 'palette.tertiary.0',
        text: 'palette.primary.90',
      },
    },
    text: 'palette.tertiary.60',
  },
  pinColumnShadow: 'palette.black:0.5',
  progressCell: progressCellTheme,
  rowCell: rowCellTheme,
  skeleton: {
    bgEnd: 'palette.surface.3',
    bgStart: 'palette.surface.4',
    borderColor: 'palette.transparent',
    borderRadius: '10px',
    borderWidth: '0px',
  },
};
